@if (visible$ | async) {
  <app-chart-tile
    [title]="'energy-valve-heat-and-flow-chart.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
